import { render, staticRenderFns } from "./NavigationItems.vue?vue&type=template&id=f80dbb96&scoped=true&"
import script from "./NavigationItems.vue?vue&type=script&lang=js&"
export * from "./NavigationItems.vue?vue&type=script&lang=js&"
import style0 from "./NavigationItems.vue?vue&type=style&index=0&id=f80dbb96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80dbb96",
  null
  
)

export default component.exports